var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("privacy_form_protocol"),
                    "label-for": "protocol"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "protocol",
                      value: _vm._.get(_vm.requestForm, "protocol_number"),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "print:hidden content-center", attrs: { md: "3" } },
            [
              _c("ProtocolQueryHistoryPopup", {
                attrs: {
                  protocol_number: _vm._.get(
                    _vm.requestForm,
                    "protocol_number"
                  ),
                  type: "lgpd"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("privacy_form_request"),
                    "label-for": "request"
                  }
                },
                [
                  _c("v-select", {
                    attrs: {
                      readonly: "",
                      searchable: false,
                      clearable: false,
                      multiple: "",
                      dir: "ltr",
                      value: _vm._.get(
                        _vm.requestForm,
                        "request_form_lgpd.categories"
                      ),
                      noDrop: "",
                      options: _vm.requestCategoryList,
                      label: "name"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selected-option-container",
                        fn: function(ref) {
                          var option = ref.option
                          return [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                staticClass: "vs__selected ",
                                attrs: { title: option.description }
                              },
                              [_vm._v(_vm._s(option.name) + " ")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _vm._.get(_vm.requestForm, "request_form_lgpd.legal_entity.id")
            ? _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("privacy_form_legal_document"),
                        "label-for": "unity"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "unity",
                          value: _vm._.get(
                            _vm.requestForm,
                            "request_form_lgpd.legal_entity.cnpj_formmated"
                          ),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "b-col",
            { attrs: { md: "8" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("privacy_form_unity"),
                    "label-for": "unity"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "unity",
                      value: _vm._.get(
                        _vm.requestForm,
                        "request_form_lgpd.legal_entity.name"
                      )
                        ? _vm._.get(
                            _vm.requestForm,
                            "request_form_lgpd.legal_entity.name"
                          )
                        : "Outras",
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "4" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("privacy_form_requester"),
                    "label-for": "requester"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "requester",
                      value: _vm._.get(
                        _vm.requestForm,
                        "request_form_lgpd.request_type_str"
                      ),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "4" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("privacy_form_bond_type"),
                    "label-for": "bond_type"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "bond_type",
                      value: _vm._.get(
                        _vm.requestForm,
                        "request_form_lgpd.request_bond_type.name"
                      ),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "7" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("privacy_form_name"),
                    "label-for": "name"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "name",
                      value: _vm._.get(
                        _vm.requestForm,
                        "request_form_lgpd.name"
                      ),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._.get(_vm.requestForm, "request_form_lgpd.request_type") != "AN"
            ? _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: _vm.$t("privacy_form_birth_date"),
                        "label-for": "birth_date"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "birth_date",
                          value: _vm._.get(
                            _vm.requestForm,
                            "request_form_lgpd.birth_date_formatted"
                          ),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label:
                      _vm._.get(
                        _vm.requestForm,
                        "request_form_lgpd.request_type"
                      ) == "AN"
                        ? _vm.$t("privacy_form_legal_document")
                        : _vm.$t("privacy_form_document"),
                    "label-for": "document"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "document",
                      value: _vm._.get(
                        _vm.requestForm,
                        "request_form_lgpd.document_number_formmatted"
                      ),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "5" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("privacy_form_email"),
                    "label-for": "email"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "email",
                      value: _vm._.get(
                        _vm.requestForm,
                        "request_form_lgpd.email"
                      ),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "4" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("privacy_form_phone"),
                    "label-for": "phone"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "phone",
                      value: _vm._.get(
                        _vm.requestForm,
                        "request_form_lgpd.phone"
                      ),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("privacy_form_country"),
                    "label-for": "country"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "country",
                      value: _vm._.get(
                        _vm.requestForm,
                        "request_form_lgpd.country.name"
                      ),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c("b-form-group", {
                attrs: {
                  label: _vm.$t("privacy_form_description"),
                  "label-for": "description"
                }
              }),
              _c("b-form-textarea", {
                attrs: {
                  id: "description",
                  value: _vm._.get(
                    _vm.requestForm,
                    "request_form_lgpd.description"
                  ),
                  rows: "4",
                  readonly: ""
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "pt-2" },
        [
          _c(
            "b-col",
            { attrs: { md: "12" } },
            [
              _c("media-list", {
                attrs: {
                  medias: _vm.files,
                  "show-delete": false,
                  "action-on-click": true
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "m-0" },
        [
          _c(
            "b-col",
            { attrs: { lg: "12" } },
            [
              _c("h5", { staticClass: "mt-2 mb-0" }, [
                _vm._v(_vm._s(_vm.$t("privacy_form_handling")))
              ]),
              _c("vs-divider")
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "m-0" },
        [
          _c(
            "b-col",
            { attrs: { lg: "4" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("privacy_form_status"),
                    "label-for": "status"
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      id: "status",
                      value: _vm._.get(
                        _vm.requestForm,
                        "request_form_handling.status_str"
                      ),
                      readonly: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "print:hidden content-center", attrs: { lg: "8" } },
            [
              _c("HandlingHistoryPopup", {
                attrs: {
                  id: _vm.id,
                  serviceDelegate: _vm.services.privacyFormHandlingService
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }